<template>
  <div ref="controls" class="controls">
    <div class="controls_left">
      <img src="~@/assets/img/cloudClassCenter/zhibo.png" alt="">
    </div>

    <div class="controls_right">
      <img @click="isShowDanMuFn" width="40px" :src="danMuSrc" alt="">
      <img @click="control_btn" class="full" width="15px" height="15px" :src="src" alt="">
    </div>

  </div>
</template>

<script>
export default {
  name: "Controls",
  data() {
    return {
      src: require("@/assets/img/cloudClassCenter/full_screen.png"),
      isFull: true,
      isShowDanMu: true,
      danMuSrc: require("@/assets/img/cloudClassCenter/danMuOpen.png")
    };
  },

  methods: {
    control_btn(e) {
      if (this.isFull) {
        this.src = require("@/assets/img/cloudClassCenter/shrink.png");
        this.isFull = !this.isFull;
      } else {
        this.src = require("@/assets/img/cloudClassCenter/fullscreen.png");
        this.isFull = !this.isFull;
      }
      this.$emit("control_btn", "full");
    },

    //是否显示弹幕
    isShowDanMuFn() {
      this.isShowDanMu = !this.isShowDanMu;
      if (this.isShowDanMu) {
        this.danMuSrc = require("@/assets/img/cloudClassCenter/danMuOpen.png");
      } else {
        this.danMuSrc = require("@/assets/img/cloudClassCenter/danMuClose.png");
      }
    }
  },

  watch: {
    isShowDanMu(newVal) {
      this.$emit("isShowDanMu", newVal);
    }
  }
};
</script>

<style lang="less" scoped>
.controls {
  display: flex;

  position: absolute;
  bottom: 0;
  left: 0;

  padding: 0 11px;
  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.5);

  align-items: center;
  justify-content: space-between;

  .controls_right {
    img {
      cursor: pointer;
    }
  }

  .controls_left,
  .controls_right {
    display: flex;

    align-items: center;
  }

  .time {
    margin-left: 9px;

    font-family: Microsoft YaHei;
    font-size: 12px;
    font-weight: 400;

    color: #fff;
  }

  .full {
    margin-left: 30px;
    width: 18px;
    height: 18px;
  }
}
</style>